(() => {
  if (window.__seshCROSuiteLoaded) return;
  window.__seshCROSuiteLoaded = true;

  const STORE = {
    wishlist: 'sesh:wishlist:v1',
    recent: 'sesh:recent:v1'
  };

  const read = (key, fallback = []) => {
    try { return JSON.parse(localStorage.getItem(key) || JSON.stringify(fallback)); }
    catch (e) { return fallback; }
  };

  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  };

  const toast = (message) => {
    let el = document.querySelector('[data-sesh-toast]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'sesh-toast';
      el.dataset.seshToast = '';
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._timer);
    el._timer = setTimeout(() => el.classList.remove('is-visible'), 1800);
  };

  const getCurrentProduct = () => {
    const el = document.querySelector('[data-sesh-product-data]');
    if (!el) return null;
    return {
      handle: el.dataset.handle,
      title: el.dataset.title,
      url: el.dataset.url,
      image: el.dataset.image,
      price: Number(el.dataset.price || 0),
      priceFormatted: el.dataset.priceFormatted || '',
      variantId: Number(el.dataset.variantId || 0)
    };
  };

  const quickAdd = async (variantId, button) => {
    if (!variantId || !button || button.disabled) return;
    const old = button.textContent;
    button.disabled = true;
    button.textContent = button.dataset.addingLabel || '...';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id:Number(variantId),quantity:1}]})
      });
      if (!response.ok) throw new Error('add');
      button.textContent = button.dataset.addedLabel || '✓';
      toast(document.documentElement.lang === 'ar' ? 'تمت الإضافة للسلة' : 'Added to cart');
      if (typeof window.refreshCart === 'function') window.refreshCart();
      setTimeout(() => { button.disabled = false; button.textContent = old; }, 900);
    } catch (e) {
      button.disabled = false;
      button.textContent = old;
    }
  };

  const updateWishlistUI = () => {
    const list = read(STORE.wishlist);
    const current = getCurrentProduct();
    document.querySelectorAll('[data-sesh-wishlist-count]').forEach(el => el.textContent = list.length);
    document.querySelectorAll('[data-sesh-open-wishlist]').forEach(el => el.hidden = list.length === 0);
    document.querySelectorAll('[data-sesh-wishlist-toggle]').forEach(button => {
      const saved = current && list.some(item => item.handle === current.handle);
      button.classList.toggle('is-saved', Boolean(saved));
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      const label = button.querySelector('[data-sesh-wishlist-label]');
      if (label) label.textContent = saved
        ? (document.documentElement.lang === 'ar' ? 'محفوظ' : 'Saved')
        : (document.documentElement.lang === 'ar' ? 'احفظيه' : 'Save');
    });
    renderWishlist(list);
  };

  const renderWishlist = (items = read(STORE.wishlist)) => {
    const holder = document.querySelector('[data-sesh-wishlist-list]');
    const empty = document.querySelector('[data-sesh-wishlist-empty]');
    if (!holder) return;
    holder.innerHTML = '';
    if (empty) empty.hidden = items.length > 0;
    items.forEach(item => {
      const row = document.createElement('div');
      row.className = 'sesh-wishlist-item';
      row.innerHTML =
        '<img src="' + (item.image || '') + '" alt="">' +
        '<div><a href="' + item.url + '">' + item.title + '</a><small>' + (item.priceFormatted || '') + '</small></div>' +
        '<button type="button" data-sesh-wishlist-remove="' + item.handle + '">×</button>';
      holder.appendChild(row);
    });
  };

  const trackRecent = () => {
    const current = getCurrentProduct();
    if (!current) return;
    let list = read(STORE.recent);
    list = list.filter(item => item.handle !== current.handle);
    list.unshift(current);
    write(STORE.recent, list.slice(0, 8));
  };

  const renderRecent = () => {
    const section = document.querySelector('[data-sesh-recent-section]');
    const grid = document.querySelector('[data-sesh-recent-grid]');
    if (!section || !grid) return;
    const current = getCurrentProduct();
    const list = read(STORE.recent).filter(item => !current || item.handle !== current.handle).slice(0, 4);
    if (!list.length) return;
    grid.innerHTML = '';
    list.forEach(item => {
      const card = document.createElement('article');
      card.className = 'sesh-recent-card';
      card.innerHTML =
        '<a href="' + item.url + '"><img src="' + (item.image || '') + '" alt=""><span>' + item.title + '</span></a>' +
        '<small>' + (item.priceFormatted || '') + '</small>' +
        (item.variantId ? '<button type="button" data-sesh-quick-add data-variant-id="' + item.variantId + '">' + (document.documentElement.lang === 'ar' ? 'أضيفي للسلة' : 'Add to cart') + '</button>' : '');
      grid.appendChild(card);
    });
    section.hidden = false;
  };

  const openDialog = (selector) => {
    const d = document.querySelector(selector);
    if (d && typeof d.showModal === 'function') d.showModal();
  };

  const closeDialog = (button) => {
    const d = button.closest('dialog');
    if (d) d.close();
  };

  const syncRestock = () => {
    const trigger = document.querySelector('[data-sesh-restock-trigger]');
    if (!trigger) return;
    const add = document.querySelector('[data-js-product-add-to-cart]');
    const unavailable = !add || add.disabled || add.classList.contains('disabled');
    trigger.classList.toggle('is-hidden', !unavailable);
    const select = document.querySelector('select[name="id"], input[name="id"]');
    const hidden = document.querySelector('[data-sesh-restock-variant]');
    if (hidden && select) hidden.value = select.value;
  };

  const initVariantRestock = () => {
    document.querySelectorAll('product-variants').forEach(el => el.addEventListener('VARIANT_CHANGE', () => setTimeout(syncRestock, 0)));
    setTimeout(syncRestock, 200);
  };

  const finderState = { goal: '', count: 2, page: 0, picks: [], browseCategory: 'all' };

  const finderGoalPriority = {
    anti_ageing:{
      'effective-magic-anti-wrinkles-cream':100,
      'sesh-ready-in-action':98,
      'baby-blue-morning-serum-with-spf30':94,
      'sesh-effective-boost':92,
      'nighty-night-cream':90
    },
    brightening:{
      'sesh-happy-glow':100,
      'sesh-smart-bright':98,
      'baby-blue-morning-serum-with-spf30':88,
      'nighty-night-cream':80,
      'more-than-sunscreen-cream-gel-spf50':72
    },
    oily:{
      'super-smooth-pore-refining-gel':100,
      'super-clear-mattifying-cream':98,
      'super-cleanse-combination-to-oily-skin-cleanser':96
    },
    hydration:{
      'baby-blue-morning-serum-with-spf30':110,
      'nighty-night-cream':108,
      'sesh-effective-boost':100,
      'sesh-ready-in-action':88,
      'sesh-happy-glow':78
    },
    sunscreen:{
      'simply-one-sunscreen-fluid-spf50-50ml':100,
      'more-than-sunscreen-cream-gel-spf50':98
    },
    fragrance:{
      'sesh-love-by-sheeka-fragrance-mist':96,
      'sesh-sweet-escape-fragrance-mist':96,
      'sesh-candy-fantasy-fragrance-mist':96,
      'sesh-berry-alure-fragrance-mist':94,
      'sesh-queens-garden-fragrance-mist':94,
      'sesh-secrets-of-cairo-fragrance-mist':94
    },
    body:{
      'happy-shine-dry-oil':100,
      'sesh-love-by-sheeka-body-lotion':96,
      'sesh-berry-alure-body-lotion':94,
      'sesh-queens-garden-body-lotion':94,
      'sesh-secrets-of-cairo-body-lotion':94
    },
    teeth:{'thirty-seconds-teeth-whitening-gel':100},
    nails:{'sesh-best-nails-ever-nail-serum':100}
  };

  const finderCatalog = () => [...document.querySelectorAll('[data-sesh-finder-product]')].map(el => ({
    handle: el.dataset.handle || '',
    category: el.dataset.category || 'more',
    goals: (el.dataset.goals || '').split(',').filter(Boolean),
    title: el.dataset.title || '',
    url: el.dataset.url || '',
    image: el.dataset.image || '',
    price: Number(el.dataset.price || 0),
    priceFormatted: el.dataset.priceFormatted || '',
    variantId: Number(el.dataset.variantId || 0),
    variantTitle: el.dataset.variantTitle || '',
    available: el.dataset.available === 'true',
    isNew: el.dataset.new === 'true',
    isBest: el.dataset.best === 'true',
    hidden: el.dataset.hidden === 'true',
    inventory: Number(el.dataset.inventory || 0),
    type: el.dataset.type || ''
  }));

  const finderMoney = cents => {
    const sample = finderCatalog().find(item => item.priceFormatted)?.priceFormatted || '';
    const number = (Number(cents || 0) / 100).toLocaleString(document.documentElement.lang === 'ar' ? 'ar-EG' : 'en-EG', {maximumFractionDigits: 0});
    if (sample.includes('LE') || sample.includes('EGP')) return number + ' LE';
    return number + ' LE';
  };

  const setFinderMode = mode => {
    document.querySelectorAll('[data-sesh-finder-mode]').forEach(button => button.classList.toggle('is-selected', button.dataset.seshFinderMode === mode));
    document.querySelectorAll('[data-sesh-finder-panel]').forEach(panel => {
      panel.hidden = panel.dataset.seshFinderPanel !== mode;
    });
    if (mode === 'browse') renderFinderBrowse();
  };

  const initFinder = () => {
    document.querySelectorAll('[data-sesh-finder-mode]').forEach(button => {
      button.addEventListener('click', () => setFinderMode(button.dataset.seshFinderMode));
    });

    document.querySelectorAll('[data-sesh-finder-goals] button').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelectorAll('[data-sesh-finder-goals] button').forEach(x => x.classList.remove('is-selected'));
        button.classList.add('is-selected');
        finderState.goal = button.dataset.goal;
        finderState.page = 0;
      });
    });

    document.querySelectorAll('[data-sesh-finder-count] button').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelectorAll('[data-sesh-finder-count] button').forEach(x => x.classList.remove('is-selected'));
        button.classList.add('is-selected');
        finderState.count = Number(button.dataset.count || 2);
        finderState.page = 0;
      });
    });

    document.querySelectorAll('[data-sesh-finder-categories] button').forEach(button => {
      button.addEventListener('click', () => {
        document.querySelectorAll('[data-sesh-finder-categories] button').forEach(x => x.classList.remove('is-selected'));
        button.classList.add('is-selected');
        finderState.browseCategory = button.dataset.category || 'all';
        renderFinderBrowse();
      });
    });

    document.querySelector('[data-sesh-finder-search]')?.addEventListener('input', renderFinderBrowse);
  };

  const finderCandidates = () => {
    const goal = finderState.goal;
    const budget = Number(document.querySelector('[data-sesh-finder-budget]')?.value || 160000);
    const target = budget >= 99999999 ? 90000 : Math.max(1, budget / Math.max(1, finderState.count));
    const skincareGoals = new Set(['brightening','oily','anti_ageing','hydration','sunscreen']);
    const routeCategory = skincareGoals.has(goal) ? 'skincare' : goal;
    const priorityMap = finderGoalPriority[goal] || {};
    const allowedHandles = new Set(Object.keys(priorityMap));

    return finderCatalog()
      .filter(item =>
        !item.hidden &&
        item.available &&
        item.inventory !== 0 &&
        item.goals.includes(goal) &&
        (!routeCategory || item.category === routeCategory) &&
        (!allowedHandles.size || allowedHandles.has(item.handle)) &&
        (budget >= 99999999 || item.price <= budget)
      )
      .map(item => {
        const routePriority = Number.isFinite(priorityMap[item.handle]) ? priorityMap[item.handle] : 45;
        const priceFit = Math.max(0, 10 - Math.abs(item.price - target) / 15000);
        const newBoost = item.isNew ? 3 : 0;
        const bestBoost = item.isBest ? 0.5 : 0;
        const stockBoost = item.inventory > 0 && item.inventory < 25 ? -4 : 2;
        return {...item, score: routePriority + priceFit + newBoost + bestBoost + stockBoost};
      })
      .sort((a,b) => b.score - a.score || a.price - b.price);
  };

  const finderSets = () => {
    const candidates=finderCandidates();
    const wanted=Math.max(1,Math.min(5,Number(finderState.count||2)));
    const budget=Number(document.querySelector('[data-sesh-finder-budget]')?.value || 160000);
    if(candidates.length<wanted) return [];
    const sets=[];
    const walk=(start,picked,total,score)=>{
      if(picked.length===wanted){
        if(budget>=99999999||total<=budget) sets.push({items:[...picked],total,score});
        return;
      }
      const need=wanted-picked.length;
      for(let i=start;i<=candidates.length-need;i++){
        const item=candidates[i];
        const nextTotal=total+item.price;
        if(budget<99999999&&nextTotal>budget) continue;
        picked.push(item);
        walk(i+1,picked,nextTotal,score+item.score);
        picked.pop();
      }
    };
    walk(0,[],0,0);
    return sets.sort((a,b)=>b.score-a.score||a.total-b.total);
  };

  const pickFinderSet = () => {
    const sets=finderSets();
    if(!sets.length) return [];
    finderState.page=((finderState.page%sets.length)+sets.length)%sets.length;
    return sets[finderState.page].items;
  };

  const renderFinderPicks = () => {
    const wrap = document.querySelector('[data-sesh-finder-results]');
    const grid = document.querySelector('[data-sesh-finder-results-grid]');
    const total = document.querySelector('[data-sesh-finder-total]');
    const count = document.querySelector('[data-sesh-finder-result-count]');
    if (!wrap || !grid) return;

    const picks = pickFinderSet();
    finderState.picks = picks;
    grid.innerHTML = '';

    if (!picks.length) {
      const routeCount=finderCandidates().length;
      const wanted=Math.max(1,Math.min(5,Number(finderState.count||2)));
      grid.innerHTML = '<p>' + (document.documentElement.lang === 'ar'
        ? (routeCount ? 'المسار ده فيه '+routeCount.toLocaleString('ar-EG')+' اختيار متاح حاليًا، ومش ممكن أكون '+wanted.toLocaleString('ar-EG')+' منتجات مختلفة ضمن الميزانية دي. قللي العدد أو زوّدي الميزانية.' : 'مفيش منتجات متاحة حاليًا للمسار ده.')
        : (routeCount ? 'This route currently has '+routeCount+' available option'+(routeCount===1?'':'s')+', so I cannot build '+wanted+' different products within this budget. Reduce the item count or increase the budget.' : 'No available products match this route right now.')) + '</p>';
      if (total) total.textContent = '';
      if (count) count.textContent = '';
      wrap.hidden = false;
      return;
    }

    picks.forEach(item => {
      const row = document.createElement('div');
      row.className = 'sesh-finder-result';
      const badges = item.isNew ? '<span class="sesh-finder-badge">' + (document.documentElement.lang === 'ar' ? 'جديد' : 'New') + '</span>' : '';
      row.innerHTML =
        '<img src="' + (item.image || '') + '" alt="">' +
        '<div>' + badges + '<a href="' + item.url + '">' + item.title + '</a><small>' + item.priceFormatted + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' · ' + item.variantTitle : '') + '</small></div>' +
        '<button type="button" data-sesh-quick-add data-variant-id="' + item.variantId + '">' + (document.documentElement.lang === 'ar' ? 'أضيفي' : 'Add') + '</button>';
      grid.appendChild(row);
    });

    const regularTotal = picks.reduce((sum,item) => sum + item.price, 0);
    if (total) total.innerHTML =
      '<span>' + (document.documentElement.lang === 'ar' ? 'الإجمالي قبل العروض' : 'Total before offers') + '</span>' +
      '<strong>' + finderMoney(regularTotal) + '</strong>';
    if (count) count.textContent = picks.length + ' / ' + finderCandidates().length;
    wrap.hidden = false;
    wrap.scrollIntoView({behavior:'smooth',block:'nearest'});
  };

  const runFinder = () => {
    if (!finderState.goal) {
      toast(document.documentElement.lang === 'ar' ? 'اختاري هدفك الأول' : 'Choose your goal first');
      return;
    }
    finderState.page = 0;
    renderFinderPicks();
  };

  const addFinderPicks = async button => {
    const items = finderState.picks.filter(item => item.available && item.variantId).map(item => ({id:item.variantId,quantity:1}));
    if (!items.length || !button || button.disabled) return;
    const old = button.textContent;
    button.disabled = true;
    button.textContent = document.documentElement.lang === 'ar' ? 'جاري الإضافة…' : 'Adding…';
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items})
      });
      if (!response.ok) throw new Error('add');
      if (typeof window.refreshCart === 'function') window.refreshCart();
      button.textContent = document.documentElement.lang === 'ar' ? 'تمت الإضافة ✓' : 'Added ✓';
      toast(document.documentElement.lang === 'ar' ? 'اتضافوا للسلة. Shopify حسب العرض الحالي تلقائيًا.' : 'Added to cart. Shopify applied the current offer automatically.');
      setTimeout(() => { button.disabled = false; button.textContent = old; }, 1300);
    } catch (e) {
      button.disabled = false;
      button.textContent = old;
    }
  };

  const finderBrowseCard = item => {
    const card = document.createElement('article');
    card.className = 'sesh-finder-product-card';
    const badges = [
      item.isNew ? (document.documentElement.lang === 'ar' ? 'جديد' : 'New') : '',
      !item.available ? (document.documentElement.lang === 'ar' ? 'غير متاح' : 'Sold out') : ''
    ].filter(Boolean).map(x => '<span>' + x + '</span>').join('');
    card.innerHTML =
      '<a class="sesh-finder-product-card__image" href="' + item.url + '"><img src="' + (item.image || '') + '" alt=""></a>' +
      '<div class="sesh-finder-product-card__badges">' + badges + '</div>' +
      '<a class="sesh-finder-product-card__title" href="' + item.url + '">' + item.title + '</a>' +
      '<small>' + item.priceFormatted + (item.variantTitle && item.variantTitle !== 'Default Title' ? ' · ' + item.variantTitle : '') + '</small>' +
      '<div class="sesh-finder-product-card__actions">' +
        '<a href="' + item.url + '">' + (document.documentElement.lang === 'ar' ? 'شوفي المنتج' : 'View') + '</a>' +
        (item.available ? '<button type="button" data-sesh-quick-add data-variant-id="' + item.variantId + '">' + (document.documentElement.lang === 'ar' ? 'أضيفي' : 'Add') + '</button>' : '') +
      '</div>';
    return card;
  };

  const renderFinderBrowse = () => {
    const grid = document.querySelector('[data-sesh-finder-browse-grid]');
    const count = document.querySelector('[data-sesh-finder-browse-count]');
    if (!grid) return;
    const term = (document.querySelector('[data-sesh-finder-search]')?.value || '').trim().toLowerCase();
    const category = finderState.browseCategory;
    let items = finderCatalog().filter(item => {
      if(item.hidden) return false;
      const categoryMatch = category === 'all' || item.category === category;
      const termMatch = !term || item.title.toLowerCase().includes(term) || item.type.toLowerCase().includes(term);
      return categoryMatch && termMatch;
    });
    items.sort((a,b) => Number(b.isNew) - Number(a.isNew) || Number(b.available) - Number(a.available) || a.title.localeCompare(b.title));
    grid.innerHTML = '';
    items.forEach(item => grid.appendChild(finderBrowseCard(item)));
    if (count) count.textContent = items.length + ' ' + (document.documentElement.lang === 'ar' ? 'منتج' : 'products');
  };

  const reviewKeywords = {
    oily: ['oily','oil','دهني','دهنية','دهنيه'],
    dry: ['dry','جاف','جافة','جفاف'],
    pigmentation: ['pigment','dark spot','تفتيح','تصبغ','تصبغات','بقع'],
    pores: ['pore','pores','مسام'],
    fragrance: ['smell','scent','fragrance','perfume','ريحة','رائحه','عطر','برفان']
  };

  const reviewRating = (review) => {
    const rating = review.querySelector('.jdgm-rev__rating');
    if (!rating) return 0;
    const raw = rating.dataset.score || rating.getAttribute('data-score') || rating.getAttribute('title') || rating.getAttribute('aria-label') || '';
    const match = String(raw).match(/([0-5](?:\.\d+)?)/);
    return match ? Number(match[1]) : 0;
  };

  const initReviewFilters = () => {
    const reviews = [...document.querySelectorAll('.jdgm-rev')];
    if (reviews.length < 3 || document.querySelector('[data-sesh-review-filter]')) return false;
    const parent = reviews[0].parentElement;
    if (!parent) return false;

    const filters = [
      {id:'all',label: document.documentElement.lang === 'ar' ? 'الكل' : 'All'},
      {id:'5',label:'5★'},
      {id:'4',label:'4★'},
      {id:'low',label: document.documentElement.lang === 'ar' ? '3★ وأقل' : '3★ & below'},
      {id:'oily',label: document.documentElement.lang === 'ar' ? 'بشرة دهنية' : 'Oily skin'},
      {id:'dry',label: document.documentElement.lang === 'ar' ? 'بشرة جافة' : 'Dry skin'},
      {id:'pigmentation',label: document.documentElement.lang === 'ar' ? 'تصبغات' : 'Pigmentation'},
      {id:'pores',label: document.documentElement.lang === 'ar' ? 'مسام' : 'Pores'},
      {id:'fragrance',label: document.documentElement.lang === 'ar' ? 'الرائحة' : 'Fragrance'}
    ];

    const bar = document.createElement('div');
    bar.className = 'sesh-review-filter';
    bar.dataset.seshReviewFilter = '';

    filters.forEach((f,index) => {
      if (reviewKeywords[f.id]) {
        const exists = reviews.some(r => reviewKeywords[f.id].some(k => r.textContent.toLowerCase().includes(k)));
        if (!exists) return;
      }
      const b = document.createElement('button');
      b.type = 'button';
      b.textContent = f.label;
      b.dataset.filter = f.id;
      if (index === 0) b.classList.add('is-selected');
      b.addEventListener('click', () => {
        bar.querySelectorAll('button').forEach(x => x.classList.remove('is-selected'));
        b.classList.add('is-selected');
        reviews.forEach(review => {
          const rating = reviewRating(review);
          const text = review.textContent.toLowerCase();
          let show = f.id === 'all';
          if (f.id === '5') show = rating >= 4.5;
          if (f.id === '4') show = rating >= 3.5 && rating < 4.5;
          if (f.id === 'low') show = rating > 0 && rating < 3.5;
          if (reviewKeywords[f.id]) show = reviewKeywords[f.id].some(k => text.includes(k));
          review.style.display = show ? '' : 'none';
        });
      });
      bar.appendChild(b);
    });

    parent.insertBefore(bar, reviews[0]);
    return true;
  };

  const observeReviews = () => {
    if (initReviewFilters()) return;
    const obs = new MutationObserver(() => {
      if (initReviewFilters()) obs.disconnect();
    });
    obs.observe(document.body,{childList:true,subtree:true});
    setTimeout(() => obs.disconnect(),12000);
  };

  document.addEventListener('click', event => {
    const quick = event.target.closest('[data-sesh-quick-add]');
    if (quick) {
      event.preventDefault();
      quickAdd(quick.dataset.variantId, quick);
      return;
    }

    const wish = event.target.closest('[data-sesh-wishlist-toggle]');
    if (wish) {
      const current = getCurrentProduct();
      if (!current) return;
      let list = read(STORE.wishlist);
      const exists = list.some(item => item.handle === current.handle);
      list = exists ? list.filter(item => item.handle !== current.handle) : [current, ...list.filter(item => item.handle !== current.handle)].slice(0, 20);
      write(STORE.wishlist, list);
      updateWishlistUI();
      toast(exists
        ? (document.documentElement.lang === 'ar' ? 'اتشال من المحفوظات' : 'Removed from saved')
        : (document.documentElement.lang === 'ar' ? 'اتحفظ' : 'Saved'));
      return;
    }

    const remove = event.target.closest('[data-sesh-wishlist-remove]');
    if (remove) {
      write(STORE.wishlist, read(STORE.wishlist).filter(item => item.handle !== remove.dataset.seshWishlistRemove));
      updateWishlistUI();
      return;
    }

    if (event.target.closest('[data-sesh-open-finder]')) openDialog('[data-sesh-finder-dialog]');
    if (event.target.closest('[data-sesh-open-wishlist]')) openDialog('[data-sesh-wishlist-dialog]');
    if (event.target.closest('[data-sesh-open-restock]')) openDialog('[data-sesh-restock-dialog]');

    const close = event.target.closest('[data-sesh-dialog-close]');
    if (close) closeDialog(close);

    if (event.target.closest('[data-sesh-finder-submit]')) runFinder();
    const addAll = event.target.closest('[data-sesh-finder-add-all]');
    if (addAll) addFinderPicks(addAll);
    if (event.target.closest('[data-sesh-finder-prev]')) {
      finderState.page -= 1;
      renderFinderPicks();
    }
    if (event.target.closest('[data-sesh-finder-next]')) {
      finderState.page += 1;
      renderFinderPicks();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    trackRecent();
    renderRecent();
    updateWishlistUI();
    initFinder();
    initVariantRestock();
    observeReviews();
  });
})();